module.exports = __webpack_public_path__ + "media/slide2/contractMediaSlide2Part3-7602ba83.png";